// export type CommentsThreadWithRelations = CommentsWithRelations['comments']
// export type CommentsWithAuthor = CommentsWithRelations['comments']
// export type CommentWithAuthor = CommentsWithAuthor[number]
import { CommentWithAuthor, VERY_VERY_LONG_TYPE_NAME } from '@repo/database'
export const formatComment = (comment: CommentWithAuthor, userId: string) => {
	const { author, ...rest } = comment
	const { email, firstName, lastName, user } = author
	const userImageUrl = user?.userImage?.url || null
	const isAuthor = author.userId === userId
	return {
		...rest,
		email,
		firstName,
		lastName,
		userImageUrl,
		...(isAuthor && { isAuthor }),
	}
}
export type CommentFormatted = ReturnType<typeof formatComment>
export type AllCommentsFormatted = {
	[storyStep: string]: {
		[field: string]: {
			comments: CommentFormatted[]
		}
	}
}
